module.exports = __webpack_public_path__ + "media/src/images/landing/kids_header-9aa5ae888ea8bef14f243ddad88e8e7b.svg";